import { Crosshair } from "lucide-react";

export default function Footer({ cashappHandle = "$biipodmodding" }) {
  return (
    <footer className="relative border-t border-zinc-900 bg-black" data-testid="footer">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-3 bo2-tape opacity-40"
        aria-hidden
      />
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-12 lg:px-20">
        <div className="flex items-center gap-3">
          <span className="grid h-9 w-9 place-items-center border border-[#ff6b00] bg-black text-[#ff6b00]">
            <Crosshair className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <div>
            <div className="font-display text-xl tracking-widest text-zinc-100">
              BIIPOD<span className="text-[#ff6b00]">.</span>MODDING
            </div>
            <div className="font-mono-hud text-[11px] uppercase tracking-widest text-zinc-500">
              BO2 Account Ops · CashApp: {cashappHandle}
            </div>
          </div>
        </div>
        <div className="font-mono-hud text-[11px] uppercase tracking-widest text-zinc-500">
          © {new Date().getFullYear()} Biipod Modding · Not affiliated with Activision or Treyarch.
        </div>
      </div>
    </footer>
  );
}
